import { useState } from 'react';
import { Alert, Button, Col, Row, Space, Spin, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowRightOutlined } from '@ant-design/icons';
import { updateExtraParam } from 'store/user';
import PropTypes from 'prop-types';
import EbzModal from 'components/EbzModal';
import utilsAPI from 'services/other';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';
import BharatConnect from '../../assets/images/bharat_connect.svg';
import SuccessTick from '../../assets/images/success.svg';

import { CONSENT, TELLER, TELLER_REDIRECT_URL } from './const';

function TellerConset(props) {
  const [isTellerConsent, setIsTellerConset] = useState(
    useSelector((state) => state.user.extraParam.isTellerConset)
  );
  const extraParamState = useSelector((state) => state.user.extraParam);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [onSuccess, setOnSuccess] = useState(false);
  const { handleConsentCancel } = props;

  const handleTellerConsent = async () => {
    try {
      trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: 'Teller Consent Agree' });
      setLoading(true);
      const response = await utilsAPI.partnerExternalEntity({
        external_entity: TELLER,
        service: CONSENT
      });
      if (!response.success) {
        setLoading(false);
        Alert('Oops!!!', `Something went wrong. Try again`, 'error');
      }
      setLoading(false);
      setIsTellerConset(true);
      setOnSuccess(true);
    } catch (error) {
      Alert('Oops!!!', `Something went wrong. Try again. ${error}`, 'error');
      throw error;
    }
  };
  const handleOnSuccess = () => {
    setOnSuccess(false);
    dispatch(updateExtraParam({ ...extraParamState, is_teller_consent: true }));
  };

  return (
    <>
      <EbzModal
        toggleModal={handleConsentCancel}
        title=""
        width={600}
        topOffset={200}
        isOpen={!isTellerConsent}
      >
        <Spin spinning={loading}>
          <Space direction="vertical" style={{ padding: '2%' }}>
            <img src={BharatConnect} alt="Bharat Connect" style={{ marginRight: '8px' }} />
            <Space direction="vertical">
              <Typography.Text style={{ fontSize: '18px' }} strong>
                Important Update : New Invoice Process!
              </Typography.Text>
              <Typography style={{ fontSize: '15px' }}>
                Easebuzz is excited to announce our integration with NPCI Bharat Bill Pay Ltd’s
                (NBBL) Bharat Connect for Business Platform as part of our new offering,
                <b> Teller</b> —a powerful solution to simplify and optimize your invoicing,
                payments and reconciliation process.
              </Typography>
              <Typography>
                <b>Join Teller</b> to continue raising invoices with Easebuzz while seamlessly
                managing invoices raised by and for other businesses—all on one integrated platform.
              </Typography>
              <Typography style={{ color: 'grey' }}>
                Click “I agree” to proceed for registration or “Learn More” to explore how Teller
                can elevate your business operations.
              </Typography>
              <Row justify="end" gutter={16}>
                <Col>
                  <a
                    href={TELLER_REDIRECT_URL}
                    style={{ color: 'var(--color-primary)', textAlign: 'center' }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn More
                  </a>
                </Col>
                <Col>
                  <Button type="primary" onClick={handleTellerConsent} suffix="lskcnkjasb">
                    I Agree <ArrowRightOutlined />
                  </Button>
                </Col>
              </Row>
            </Space>
          </Space>
        </Spin>
      </EbzModal>
      <EbzModal
        toggleModal={handleOnSuccess}
        title=""
        width={650}
        topOffset={200}
        isOpen={onSuccess}
      >
        <Space direction="vertical" align="center" style={{ padding: '5%' }}>
          <img src={SuccessTick} alt="Bharat Connect" style={{ marginRight: '8px' }} />
          <Typography.Text style={{ fontSize: '20px' }} strong>
            You’re All Set!
          </Typography.Text>
          <center>
            <Typography style={{ fontSize: '18px' }}>
              We appreciate your interest in Teller, powered by NBBL Bharat Connect. Our team will
              reach out soon with the next steps. In the meantime, you can proceed with uploading
              your invoices seamlessly.
            </Typography>
          </center>
        </Space>
      </EbzModal>
    </>
  );
}
TellerConset.propTypes = { handleConsentCancel: PropTypes.func };
TellerConset.defaultProps = { handleConsentCancel: () => {} };

export default TellerConset;
